import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ETFowl crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', gap: 12, padding: 24, textAlign: 'center',
          background: '#0b0d10', color: '#e6e8eb', fontFamily: "'Fira Code', monospace",
        }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>發生錯誤，這個畫面暫時無法顯示</div>
          <div style={{ fontSize: 12, opacity: 0.7, maxWidth: 360 }}>可能是資料暫時取不到，重新整理通常可以解決。</div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8, padding: '8px 20px', background: '#2dd4bf', color: '#0b0d10',
              border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: 'pointer',
              fontFamily: "'Fira Code', monospace",
            }}
          >
            重新整理
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
